// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";

function Scrollable(Props) {
  var height = Props.height;
  var onScrollEndCallback = Props.onScrollEndCallback;
  var children = Props.children;
  var onScrollCallback = function ($$event) {
    var scrollHeight = $$event.target.scrollHeight;
    var clientHeight = $$event.target.clientHeight;
    var scrollTop = $$event.target.scrollTop;
    if (((scrollTop + clientHeight | 0) + 1 | 0) >= scrollHeight) {
      return Curry._1(onScrollEndCallback, undefined);
    }
    
  };
  return React.createElement("div", {
              style: {
                height: height,
                overflowY: "scroll"
              },
              onScroll: onScrollCallback
            }, children);
}

var make = Scrollable;

export {
  make ,
  
}
/* react Not a pure module */
